import { useState } from "react";
import dayjs from "dayjs";
import JDate from "jalali-date";
import React from "react";

import Container from "./index-css";
const Index = ({ data }) => {
  const [showMore1, setShowMore1] = useState(false)
  const [showMore2, setShowMore2] = useState(false)
  const [showMore3, setShowMore3] = useState(false)
    var arrPrice = []


    const detail = JSON.parse(data.data[0].request_detail_json)

    try {
        arrPrice = JSON.parse(data.data[0].jsonpricing_text)
        if (arrPrice.instalment_conditions) {
              var cash = arrPrice.instalment_conditions.filter((c) => c.instalment_conditions_mode_id === "0")
              var check = arrPrice.instalment_conditions.filter((c) => (c.instalment_conditions_mode_id === "1" || c.instalment_conditions_mode_id === "3"))
        }
  } catch (e) {
        console.log(e)
  }
  var active_star =
        parseInt(arrPrice.company_customer_satisfaction) +
        parseInt(arrPrice.company_levelof_prosperity) +
        parseInt(arrPrice.company_timeanswer_complaints)

  active_star = Math.ceil(active_star / 3 / 2)
  var deactive_star = 5 - active_star

  const Stars = () => {
        var stars = []
        for (var i = 0; i < active_star; i++) {
              stars.push(<img src="/imagess/star.png" key={i + deactive_star} alt="icon rating" />)
        }
        return <>{stars}</>
  }

  const Stars_ = () => {
        var dstars = []
        for (var i = 0; i < deactive_star; i++) {
              dstars.push(<img src="/imagess/star_.png" key={i} alt="آیکون ستاره" />)
        }
        return <>{dstars}</>
  }

  function formatPrice(value) {
        return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
  }

  const handleClick = (id) => {
        if (id === 1) {
              setShowMore1(!showMore1)
        } else if (id === 2) {
              setShowMore2(!showMore2)
        } else if (id === 3) {
              setShowMore3(!showMore3)
        }
  }


  // *******************component************component*******************component*****************component*************

  const Text = (props) => {
    return (
      <Container>
        <div  className="main-textt">
          <div className="text-title">{props.title}:</div>
          <div className="text-detail">{props.detail}</div>
        </div>
      </Container>
    );
  };

  const Linetitle = (props) => {
    return (
      <Container>
        <div className="main-line">
          <div style={{ width: "100%" }} className="line">
            <div style={{ width: props.w }} className="line-text">
              {props.name}
            </div>
          </div>
        </div>
      </Container>
    );
  };
  return (
    <Container>
      <div className="main-map-detail">
      <div className="title">
              خلاصه سفارش بیـــمه
              <span
                style={{
                  color: "#1ad4a3",
                  marginRight: "5px",
                  display: "flex",
                }}
              >
        مسافرتی
              </span>
            </div>
        <Linetitle name="اطلاعات" />
        <div className="map-detail-divv">
          <Text title="طرح مسافرتی" detail={detail.travel_plan_name} />
          <Text title="کشور مقصد اول" detail={detail.travel_destination_name} />
          <Text title="مدت بیمه" detail={detail.travel_time_name} />
          <Text
            title="0 تا 12 سال"
            detail={`${detail.travel_pasenger.travel_pasenger0_12}نفر`}
          />
          <Text title="13 تا 65 سال" detail={`${detail.travel_pasenger.travel_pasenger13_65}نفر`} />
   
       
          <Text title="66 تا 70 سال" detail={`${detail.travel_pasenger.travel_pasenger66_70}نفر`} />
          <Text title="71 تا 75 سال" detail={`${detail.travel_pasenger.travel_pasenger71_75}نفر`} />
          <Text
            title="76 تا 80 سال"
            detail={`${detail.travel_pasenger.travel_pasenger76_80}نفر`}
          />
          <Text
            title="81 تا 85 سال"
            detail={`${detail.travel_pasenger.travel_pasenger81_85}نفر`}
          />
       
    
          <Text
            title="سطح تعهدات مالی"
            detail={detail.travel_coverage_name}
          />
          <Text
            title="کمک رسان"
            detail={detail.travel_helper_name}
          />
        
        </div>

   

        <Linetitle name="اطلاعات بیمه" />
        <div className="map-detail-divv">
          <Text title="نام بیمه" detail={arrPrice.company_name} />
          <Text title="امتیاز بیمه" detail={arrPrice.company_levelof_prosperity} />
          <Text
            title="مبلغ بیمه"
            detail={`${formatPrice(arrPrice.price)} ریال`}
          />
          <Text
            title="درصد تخفیف مدیریتی"
            detail={
              arrPrice.managdiscount_amount
                ? `${arrPrice.managdiscount_amount} درصد`
                : "ندارد"
            }
          />
          <Text title="پوشش‌ بیمه‌نامه" detail={arrPrice.tip} />
  
          <Text
            title="امکان خرید اقساطی"
            detail={arrPrice.instalment_conditions ? "بله" : "خیر"}
          />
          <>
          {arrPrice.instalment_conditions && arrPrice.instalment_conditions.map((data) => (
              <Text
                title={data.instalment_conditions_desc}
                detail={data.instalment_conditions_amount}
              />
            ))}
          </>

        </div>
      </div>
    </Container>
  );
};

export default Index;
